/* Willow of the Wild – header, menu, search, and the homepage day-to-night magic */
(function () {
  'use strict';
  var doc = document, root = doc.documentElement;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && Shopify.designMode);
  if (design) root.classList.add('wotw-design');
  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function clamp(v) { return Math.max(0, Math.min(1, v)); }

  /* ===================== header, menu, search, cart ===================== */
  var bar, drawer, menuBtn, sbox, sbtn;
  function setInert(on) {
    [doc.getElementById('MainContent'), bar, $('body > footer')].forEach(function (el) {
      if (!el) return; if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    });
  }
  function setMenu(open) {
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    menuBtn && menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    doc.body.style.overflow = open ? 'hidden' : '';
    setInert(open);
    if (open) setTimeout(function () { var c = $('#wotwMenuClose'); c && c.focus({ preventScroll: true }); }, 300); else menuBtn && menuBtn.focus({ preventScroll: true });
  }
  function openSearch() { if (!sbox) return; sbox.classList.add('open'); setTimeout(function () { var q = $('#wotwQ'); q && q.focus(); }, 200); }
  function closeSearch() { if (!sbox) return; sbox.classList.remove('open'); sbtn && sbtn.focus(); }
  function barHeight() { if (bar) root.style.setProperty('--w-barh', bar.offsetHeight + 'px'); }
  function sbw() { root.style.setProperty('--w-sbw', (innerWidth - root.clientWidth) + 'px'); }

  function initHeader() {
    /* lift the header, menu and search out of the theme's section box so nothing can hide or clip them */
    var portal = doc.getElementById('wotwPortal');
    if (!portal) { portal = doc.createElement('div'); portal.id = 'wotwPortal'; portal.className = 'wotw'; doc.body.insertBefore(portal, doc.body.firstChild); }
    ['wotwBar', 'wotwSearch', 'wotwDrawer'].forEach(function (id) {
      var all = $$('[id="' + id + '"]');
      if (all.length > 1) all.forEach(function (el) { if (el.parentNode === portal) portal.removeChild(el); });
      var el = doc.getElementById(id);
      if (el && el.parentNode !== portal) portal.appendChild(el);
    });
    bar = $('#wotwBar'); drawer = $('#wotwDrawer'); menuBtn = $('#wotwMenuBtn'); sbox = $('#wotwSearch'); sbtn = $('#wotwSearchBtn');
    if (!bar) return;
    menuBtn && menuBtn.addEventListener('click', function () { setMenu(true); });
    var mc = $('#wotwMenuClose'); mc && mc.addEventListener('click', function () { setMenu(false); });
    drawer && $$('a', drawer).forEach(function (a) { a.addEventListener('click', function () { setInert(false); drawer.classList.remove('open'); doc.body.style.overflow = ''; }); });
    sbtn && sbtn.addEventListener('click', openSearch);
    var sc = $('#wotwSearchClose'); sc && sc.addEventListener('click', closeSearch);
    addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawer && drawer.classList.contains('open')) setMenu(false);
      if (sbox && sbox.classList.contains('open')) closeSearch();
    });
    if (!doc.body.classList.contains('wotw-home')) bar.classList.add('scrolled');
    barHeight(); sbw();
    addEventListener('resize', function () { barHeight(); sbw(); });
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(barHeight);
  }

  /* keep the cart count right when the theme adds things to the cart */
  function setCount(n) {
    $$('.wotw .cart [data-count]').forEach(function (el) { el.textContent = n; });
    $$('.wotw .cart').forEach(function (a) { a.setAttribute('aria-label', 'Cart, ' + n + ' items'); });
  }
  function toast(msg) {
    var t = $('#wotwToast');
    if (!t) { t = doc.createElement('div'); t.id = 'wotwToast'; t.className = 'wotw wotw-toast'; t.setAttribute('role', 'status'); doc.body.appendChild(t); }
    t.innerHTML = msg; t.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('show'); }, 4200);
  }
  doc.addEventListener('cart:update', function (e) {
    var d = (e && e.detail) || {}, data = d.data || {}, res = d.resource || {};
    if (data.didError) return;
    var n = typeof data.itemCount === 'number' ? data.itemCount : (typeof res.item_count === 'number' ? res.item_count : null);
    if (n === null) { fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {}); }
    else setCount(n);
    if (data.source !== 'cart-items-component' && !/\/cart/.test(location.pathname)) {
      var url = (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      toast('Added to your cart <a href="' + url + '">View cart</a>');
    }
  });

  /* ===================== homepage ===================== */
  var gen = 0;
  function initHome() {
    var my = ++gen;
    var opening = $('#wotwTop');
    var homeOn = doc.body.classList.contains('wotw-home');
    if (!homeOn) return;

    /* sky + willow layers live directly in <body> so nothing can trap them */
    ['[data-wotw-sky]', '[data-wotw-willow]'].forEach(function (sel) {
      var all = $$(sel);
      if (all.length > 1) all.forEach(function (el) { if (el.parentNode === doc.body) el.parentNode.removeChild(el); });
    });
    var sky = $('[data-wotw-sky]'), willowBg = $('[data-wotw-willow]');
    if (sky && sky.parentNode !== doc.body) doc.body.insertBefore(sky, doc.body.firstChild);
    if (willowBg && willowBg.parentNode !== doc.body) doc.body.insertBefore(willowBg, sky ? sky.nextSibling : doc.body.firstChild);

    /* rise + drift into view */
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -6% 0px' });
      $$('.wotw .rise').forEach(function (el, i) { el.style.transitionDelay = (el.classList.contains('card') ? (i % 4) * 70 : 0) + 'ms'; io.observe(el); });
      if (!reduce && !design) {
        var driftSel = '.wotw .willow .head > *, .wotw .willow .sub, .wotw .willow .card .meta, .wotw .ctile b, .wotw .ctile .cbtn, .wotw .dusk p, .wotw .wild .head > *, .wotw .wild .sub, .wotw .wild .card .meta, .wotw .hampers .band > div > *, .wotw .hampers li, .wotw .aboutcard > *, .wotw footer h3, .wotw footer h4, .wotw footer .cols > div > div, .wotw footer a, .wotw footer form, .wotw .socials, .wotw footer .small';
        root.classList.add('drift-on');
        var dio = new IntersectionObserver(function (es) {
          es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); dio.unobserve(en.target); } });
        }, { rootMargin: '0px 0px -12% 0px', threshold: .1 });
        var driftEls = [];
        $$(driftSel).forEach(function (el) {
          if (el.classList.contains('drift')) return;
          el.classList.add('drift');
          var sib = el.parentElement ? Array.prototype.indexOf.call(el.parentElement.children, el) : 0;
          el.style.transitionDelay = Math.min(sib, 6) * 90 + 'ms';
          driftEls.push(el);
        });
        /* start the soft appear once the visitor begins to scroll (or after the opening has played),
           so words already peeking in at the bottom on load still drift in where people can see them */
        var driftStarted = false;
        var startDrift = function () {
          if (driftStarted) return; driftStarted = true;
          removeEventListener('scroll', startDrift);
          driftEls.forEach(function (el) { dio.observe(el); });
        };
        addEventListener('scroll', startDrift, { passive: true });
        setTimeout(startDrift, 4500);
        setTimeout(function () { $$('.wotw .drift').forEach(function (el) { if (el.getBoundingClientRect().top < innerHeight * .9) el.classList.add('in'); }); }, 7000);
      }
    } else { $$('.wotw .rise').forEach(function (el) { el.classList.add('in'); }); }

    var scene = $('#wotwSplit'), introEl = $('.wotw .intro');
    var sceneSrc = (getComputedStyle(root).getPropertyValue('--w-scene').match(/url\((.*)\)/) || [])[1];
    if (sceneSrc) sceneSrc = sceneSrc.trim().replace(/^["']|["']$/g, '');

    /* ---------- her willow, swaying in the breeze (WebGL) ---------- */
    var VS = 'attribute vec2 p; varying vec2 v; void main(){ v = vec2(p.x * .5 + .5, .5 - p.y * .5); gl_Position = vec4(p, 0., 1.); }';
    var FS = [
      'precision mediump float;',
      'uniform sampler2D tex; uniform float t; uniform vec2 res; uniform vec2 img; uniform vec2 focus; uniform float bright; varying vec2 v;',
      'void main(){',
      '  float sr = res.x / res.y, ir = img.x / img.y;',
      '  vec2 sc = sr > ir ? vec2(1., ir / sr) : vec2(sr / ir, 1.);',
      '  vec2 uv = v * sc + (1. - sc) * focus;',
      '  float w = smoothstep(.04, .55, uv.y) * smoothstep(.05, .13, uv.x);',
      '  float sway = sin(t * .9 + uv.y * 6. + uv.x * 14.) * .005 + sin(t * .45 + uv.x * 5.) * .007 + sin(t * 1.7 + uv.x * 40.) * .0012;',
      '  uv.x += sway * w;',
      '  uv.y += sin(t * .7 + uv.x * 9.) * .0018 * w;',
      '  vec4 c = texture2D(tex, uv);',
      '  float d = sin(uv.x * 16. + t * .5) * sin(uv.y * 12. - t * .35) + sin(uv.x * 7. - t * .3) * .5;',
      '  c.rgb *= bright + .045 * d * smoothstep(.0, .45, uv.y);',
      '  gl_FragColor = vec4(c.rgb, 1.);',
      '}'].join('\n');
    function makeSway(cv, opts) {
      var g = null, me = { ready: false, draw: function () {}, size: function () {} };
      if (!cv) return me;
      try { g = cv.getContext('webgl', { premultipliedAlpha: false, antialias: false }); } catch (e) {}
      if (!g || !sceneSrc) return me;
      function sh(type, src) { var o = g.createShader(type); g.shaderSource(o, src); g.compileShader(o); return g.getShaderParameter(o, g.COMPILE_STATUS) ? o : null; }
      var a = sh(g.VERTEX_SHADER, VS), f = sh(g.FRAGMENT_SHADER, FS); if (!a || !f) return me;
      var pr = g.createProgram(); g.attachShader(pr, a); g.attachShader(pr, f); g.linkProgram(pr);
      if (!g.getProgramParameter(pr, g.LINK_STATUS)) return me;
      g.useProgram(pr);
      g.bindBuffer(g.ARRAY_BUFFER, g.createBuffer());
      g.bufferData(g.ARRAY_BUFFER, new Float32Array([-1, -1, 1, -1, -1, 1, 1, 1]), g.STATIC_DRAW);
      var ap = g.getAttribLocation(pr, 'p'); g.enableVertexAttribArray(ap); g.vertexAttribPointer(ap, 2, g.FLOAT, false, 0, 0);
      var L = {}; ['t', 'res', 'img', 'focus', 'tex', 'bright'].forEach(function (n) { L[n] = g.getUniformLocation(pr, n); });
      var im = new Image(); im.crossOrigin = 'anonymous';
      im.onload = function () {
        var tx = g.createTexture(); g.bindTexture(g.TEXTURE_2D, tx);
        try { g.texImage2D(g.TEXTURE_2D, 0, g.RGB, g.RGB, g.UNSIGNED_BYTE, im); } catch (e) { return; }
        [g.TEXTURE_WRAP_S, g.TEXTURE_WRAP_T].forEach(function (k) { g.texParameteri(g.TEXTURE_2D, k, g.CLAMP_TO_EDGE); });
        g.texParameteri(g.TEXTURE_2D, g.TEXTURE_MIN_FILTER, g.LINEAR); g.texParameteri(g.TEXTURE_2D, g.TEXTURE_MAG_FILTER, g.LINEAR);
        me.ready = true; me.size(); me.draw(0); if (opts.onReady) opts.onReady();
      };
      im.src = sceneSrc;
      me.size = function () {
        if (!me.ready) return;
        var r = innerWidth < 761 ? 1 : Math.min(devicePixelRatio || 1, 1.5), wh = opts.box();
        cv.width = Math.max(1, Math.round(wh[0] * r)); cv.height = Math.max(1, Math.round(wh[1] * r));
        g.viewport(0, 0, cv.width, cv.height);
      };
      me.draw = function (ts) {
        if (!me.ready) return;
        g.uniform1f(L.t, ts); g.uniform2f(L.res, cv.width, cv.height); g.uniform2f(L.img, im.width, im.height);
        var fo = opts.focus(); g.uniform2f(L.focus, fo[0], fo[1]); g.uniform1f(L.bright, opts.bright); g.uniform1i(L.tex, 0);
        g.drawArrays(g.TRIANGLE_STRIP, 0, 4);
      };
      addEventListener('resize', me.size);
      return me;
    }
    var bgSway = makeSway(willowBg ? $('canvas', willowBg) : null, {
      box: function () { return [innerWidth, innerHeight]; },
      focus: function () { return [innerWidth < 761 ? .18 : 0, 0]; }, bright: 1.1,
      onReady: function () { willowBg && willowBg.classList.add('gl'); }
    });

    /* ---------- willow leaves drifting down on the Willow half ---------- */
    var leafCv = $('#wotwLeaf'), lx = leafCv ? leafCv.getContext('2d') : null;
    var dLeaves = [], LW = 0, LH = 0, ldpr = 1;
    var leafCols = [['#8eaa94', '#568773'], ['#568773', '#3b6e5f'], ['#9cc0a8', '#6a9a84'], ['#3b6e5f', '#24463d']];
    function newLeaf(anywhere) {
      var c = leafCols[Math.floor(Math.random() * leafCols.length)];
      return { x: Math.random(), y: anywhere ? Math.random() : -.08, len: (innerWidth < 761 ? 22 : 32) + Math.random() * 24, rot: Math.random() * 6.28, vr: (Math.random() - .5) * .006,
        vy: .14 + Math.random() * .16, sw: Math.random() * 6.28, swS: .008 + Math.random() * .008, c1: c[0], c2: c[1], a: .75 + Math.random() * .25 };
    }
    function leafSetup() {
      if (!lx) return;
      ldpr = Math.min(devicePixelRatio || 1, 2);
      LW = leafCv.clientWidth; LH = leafCv.clientHeight;
      leafCv.width = LW * ldpr; leafCv.height = LH * ldpr; lx.setTransform(ldpr, 0, 0, ldpr, 0, 0);
      if (!dLeaves.length) for (var i = 0; i < (innerWidth < 761 ? 4 : 7); i++) dLeaves.push(newLeaf(true));
    }
    function drawLeaf(l) {
      var L = l.len, W = L * .17;
      lx.save(); lx.translate(l.x * LW, l.y * LH); lx.rotate(l.rot + Math.sin(l.sw) * .35); lx.globalAlpha = l.a;
      var g = lx.createLinearGradient(-W, 0, W, 0); g.addColorStop(0, l.c1); g.addColorStop(1, l.c2);
      lx.fillStyle = g; lx.beginPath(); lx.moveTo(0, -L / 2);
      lx.bezierCurveTo(W, -L * .25, W * .9, L * .2, 0, L / 2);
      lx.bezierCurveTo(-W * .9, L * .2, -W, -L * .25, 0, -L / 2); lx.fill();
      lx.strokeStyle = 'rgba(220,235,225,.35)'; lx.lineWidth = .7; lx.beginPath(); lx.moveTo(0, -L / 2 + 2); lx.lineTo(0, L / 2 - 1); lx.stroke();
      lx.restore();
    }
    function leafTick(k) {
      if (!lx) return;
      if (LW !== leafCv.clientWidth || LH !== leafCv.clientHeight) leafSetup();
      lx.clearRect(0, 0, LW, LH);
      for (var i = 0; i < dLeaves.length; i++) {
        var l = dLeaves[i];
        if (!reduce) { l.sw += l.swS * k; l.y += l.vy * k / LH * (1 + .25 * Math.sin(l.sw * 2)); l.x += Math.sin(l.sw) * .0006 * k; l.rot += l.vr * k; }
        if (l.y > 1.08) dLeaves[i] = l = newLeaf(false);
        drawLeaf(l);
      }
    }
    leafSetup();

    /* ---------- fireflies on the Wild half ---------- */
    var bc = $('#wotwBugs'), bx = bc ? bc.getContext('2d') : null, bugs = [], BW = 0, BH = 0, bdpr = 1, bugsOn = true;
    var dayHalf = scene ? $('.day', scene) : null;
    function seamX() { return dayHalf ? dayHalf.offsetWidth : 0; }
    function bugSetup() {
      if (!bx || !scene) return;
      bdpr = Math.min(devicePixelRatio || 1, 2);
      BW = scene.clientWidth; BH = scene.clientHeight;
      bc.width = BW * bdpr; bc.height = BH * bdpr; bx.setTransform(bdpr, 0, 0, bdpr, 0, 0);
      var n = BW < 700 ? 2 : 4; bugs = [];
      for (var i = 0; i < n; i++) bugs.push({ x: BW * (.56 + Math.random() * .38), y: BH * (.1 + Math.random() * .55), a: -Math.PI / 4 + (Math.random() - .5), v: .1 + Math.random() * .12, f: Math.random() * 6.28, g: Math.random() * 6.28, pink: i === 2 });
    }
    function drawBug(b, s, m) { drawBugOn(bx, b, s, m); }
    function drawBugOn(bx, b, s, m) {
      var glow = (.55 + .45 * Math.sin(b.g)) * m;
      var tail = b.pink ? [236, 190, 240] : [255, 240, 160];
      bx.save(); bx.translate(b.x, b.y); bx.rotate(b.a + Math.PI / 2);
      var gg = bx.createRadialGradient(0, s * .55, 0, 0, s * .55, s * 2.4);
      gg.addColorStop(0, 'rgba(' + tail + ',' + (.55 * glow) + ')'); gg.addColorStop(1, 'rgba(' + tail + ',0)');
      bx.fillStyle = gg; bx.beginPath(); bx.arc(0, s * .55, s * 2.4, 0, 6.28); bx.fill();
      var flap = .55 + .45 * Math.abs(Math.sin(b.f));
      bx.fillStyle = 'rgba(235,245,240,.22)'; bx.strokeStyle = 'rgba(235,245,240,.35)'; bx.lineWidth = .8;
      [-1, 1].forEach(function (d) { bx.save(); bx.rotate(d * .55); bx.scale(flap, 1); bx.beginPath(); bx.ellipse(d * s * .55, -s * .15, s * .6, s * .32, d * .3, 0, 6.28); bx.fill(); bx.stroke(); bx.restore(); });
      var tg = bx.createLinearGradient(0, s * .1, 0, s * 1.05);
      tg.addColorStop(0, 'rgba(' + tail + ',' + (.6 + .4 * glow) + ')'); tg.addColorStop(1, 'rgba(255,255,255,' + (.7 + .3 * glow) + ')');
      bx.fillStyle = tg; bx.beginPath(); bx.ellipse(0, s * .58, s * .22, s * .45, 0, 0, 6.28); bx.fill();
      bx.fillStyle = '#8a4b2b'; bx.beginPath(); bx.ellipse(0, -s * .05, s * .2, s * .26, 0, 0, 6.28); bx.fill();
      bx.fillStyle = '#3a2418'; bx.beginPath(); bx.arc(0, -s * .34, s * .12, 0, 6.28); bx.fill();
      bx.strokeStyle = '#2c1c14'; bx.lineWidth = 1;
      bx.beginPath(); bx.moveTo(-s * .05, -s * .42); bx.quadraticCurveTo(-s * .2, -s * .75, -s * .38, -s * .8); bx.moveTo(s * .05, -s * .42); bx.quadraticCurveTo(s * .2, -s * .75, s * .38, -s * .8); bx.stroke();
      bx.restore();
    }

    /* ---------- fireflies glowing under the big logo, like her artwork ---------- */
    var ib = $('#wotwIntroBugs'), ibx = ib ? ib.getContext('2d') : null, iBugs = [], IW = 0, IH = 0, logoEl = introEl ? $('.logo-big', introEl) : null, tagEl = introEl ? $('p', introEl) : null;
    function introSetup() {
      if (!ibx || !introEl) return;
      var d = Math.min(devicePixelRatio || 1, 2);
      IW = ib.clientWidth; IH = ib.clientHeight;
      ib.width = IW * d; ib.height = IH * d; ibx.setTransform(d, 0, 0, d, 0, 0);
      var ir = introEl.getBoundingClientRect(), lr = logoEl ? logoEl.getBoundingClientRect() : ir;
      var top = lr.bottom - ir.top, bot = tagEl ? tagEl.getBoundingClientRect().top - ir.top : top + 60;
      var gap = Math.max(30, bot - top), L = lr.left - ir.left, Wd = lr.width;
      var pts = [[.48, .26], [.7, .3], [.6, .78]];
      iBugs = pts.map(function (q, i) { return { hx: L + Wd * q[0], hy: top + gap * q[1], x: 0, y: 0, a: -.75 + (Math.random() - .5) * .3, f: Math.random() * 6.28, g: Math.random() * 6.28, ph: Math.random() * 6.28, pink: i === 1 }; });
    }
    var iT = 0;
    function introTick(k) {
      if (!ibx || !iBugs.length) return;
      if (IW !== ib.clientWidth || IH !== ib.clientHeight) introSetup();
      ibx.clearRect(0, 0, IW, IH);
      iT += reduce ? 0 : .011 * k;
      var s = IW < 761 ? 13 : Math.max(16, Math.min(26, IW * .016));
      iBugs.forEach(function (b) {
        b.x = b.hx + Math.sin(iT * .7 + b.ph) * (IW < 761 ? 6 : 10);
        b.y = b.hy + Math.cos(iT * .9 + b.ph) * (IW < 761 ? 4 : 6);
        if (!reduce) { b.f += .6 * k; b.g += .015 * k; }
        drawBugOn(ibx, b, s, 1.25);
      });
    }
    var bLast = 0;
    function bugTick(ts) {
      if (my !== gen) return;
      var k = (ts && bLast) ? Math.min(3, (ts - bLast) / 16.67) : 1; bLast = ts || 0;
      if (bugsOn) { leafTick(k); introTick(k); }
      if (bx && bugsOn && !doc.hidden) {
        bx.clearRect(0, 0, BW, BH);
        var s = BW < 761 ? 13 : Math.max(16, Math.min(30, BW * .02));
        bugs.forEach(function (b) {
          if (!reduce) {
            b.a += (Math.random() - .5) * .04 * k; b.f += .6 * k; b.g += .015 * k;
            b.x += Math.cos(b.a) * b.v * k; b.y += Math.sin(b.a) * b.v * k;
            var minY = BH * .08, maxY = BH * .7, minX = seamX() + 18;
            if (b.x < minX || b.x > BW * .96 || b.y < minY || b.y > maxY) b.a += Math.PI * .9;
            if (b.x < minX) b.x = minX;
            b.x = Math.max(0, Math.min(BW, b.x)); b.y = Math.max(0, Math.min(BH, b.y));
          }
          drawBug(b, s, b.x > seamX() ? 1.15 : .45);
        });
      }
      if (!reduce) requestAnimationFrame(bugTick);
    }
    if (opening && 'IntersectionObserver' in window) new IntersectionObserver(function (e) { bugsOn = e[0].isIntersecting; }).observe(opening);
    bugSetup(); introSetup(); requestAnimationFrame(bugTick);
    addEventListener('resize', function () { bugSetup(); introSetup(); });
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(introSetup);
    addEventListener('load', introSetup);

    /* ---------- the sky: day to dusk to night ---------- */
    var cv = sky, cx = cv ? cv.getContext('2d') : null;
    var ridges = [], W, H, dpr, stars = [], flies = [], leaves = [], motes = [];
    function hex(h) { return [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)]; }
    function mix(a, b, t) { a = hex(a); b = hex(b); return 'rgb(' + Math.round(a[0] + (b[0] - a[0]) * t) + ',' + Math.round(a[1] + (b[1] - a[1]) * t) + ',' + Math.round(a[2] + (b[2] - a[2]) * t) + ')'; }
    function mix3(a, b, c, t) { return t < .5 ? mix(a, b, t * 2) : mix(b, c, (t - .5) * 2); }
    function setup() {
      if (!cx) return;
      dpr = Math.min(devicePixelRatio || 1, 1.6);
      W = innerWidth; H = innerHeight;
      cv.width = W * dpr; cv.height = H * dpr;
      cx.setTransform(dpr, 0, 0, dpr, 0, 0);
      leaves = [];
      for (var li = 0; li < (W < 700 ? 5 : 9); li++) leaves.push({ x: Math.random() * W, y: Math.random() * H, r: Math.random() * 6.28, vr: (Math.random() - .5) * .008, vy: .15 + Math.random() * .2, sz: 5 + Math.random() * 5, ph: Math.random() * 6.28, c: Math.random() < .5 ? '#7fb39c' : '#a9cdb9' });
      motes = [];
      for (var mi = 0; mi < (W < 700 ? 25 : 45); mi++) motes.push({ x: Math.random(), y: Math.random(), ph: Math.random() * 6.28, r: .6 + Math.random() * 1.4 });
      ridges = [];
      var step = 6, npts = Math.ceil(W / step) + 2;
      for (var rk = 0; rk < 4; rk++) {
        var pts = [], ph = [], oc = 4, o;
        for (o = 0; o < oc; o++) ph.push(Math.random() * 100);
        for (var pi2 = 0; pi2 < npts; pi2++) {
          var xx = pi2 * step / 1400, v = 0, amp = 1, fr = 1.1 + rk * .5, norm = 0;
          for (o = 0; o < oc; o++) {
            var n2 = Math.sin(xx * fr * 6.283 + ph[o]) * .5 + Math.sin(xx * fr * 3.7 + ph[o] * 1.7) * .5;
            var rid = 1 - Math.abs(n2); v += (rk === 0 ? rid * rid : n2 * .5 + .5) * amp; norm += amp; amp *= .45; fr *= 2;
          }
          pts.push(v / norm);
        }
        var trees = [], tx2;
        if (rk === 3) for (tx2 = 0; tx2 < W; tx2 += 7 + Math.random() * 12) trees.push({ x: tx2, h: 6 + Math.random() * 16, kind: Math.random() < .3 ? 1 : 0, w: 5 + Math.random() * 8 });
        if (rk === 2) for (tx2 = 0; tx2 < W; tx2 += 14 + Math.random() * 30) trees.push({ x: tx2, h: 4 + Math.random() * 8, kind: Math.random() < .5 ? 1 : 0, w: 4 + Math.random() * 5 });
        ridges.push({ pts: pts, trees: trees, step: step });
      }
      stars = [];
      for (var s = 0; s < (W < 700 ? 70 : 140); s++) stars.push({ x: Math.random(), y: Math.random() * .6, r: Math.random() * 1.2 + .2, tw: Math.random() * 6.28 });
      flies = [];
      for (var f = 0; f < (W < 700 ? 10 : 24); f++) flies.push({ x: Math.random() * W, y: Math.random() * H, r: 1 + Math.random() * 1.8, vx: (Math.random() - .5) * .15, vy: -.05 - Math.random() * .12, ph: Math.random() * 6.28, sp: .006 + Math.random() * .012, k: Math.random() });
    }
    var nStart = 0, nEnd = 1, sceneH = 0;
    function measure() {
      var dusk = $('.wotw .dusk'), wildS = $('.wotw .wild');
      var top = function (el) { return el.getBoundingClientRect().top + scrollY; };
      if (dusk && wildS) { nStart = top(dusk) - H * .6; nEnd = top(wildS) - H * .3; }
      else if (wildS) { nStart = top(wildS) - H * 1.2; nEnd = top(wildS) - H * .3; }
      else { nStart = 1e9; nEnd = 1e9 + 1; }
      if (nEnd <= nStart) nEnd = nStart + 1;
      sceneH = opening ? opening.offsetHeight : 0;
    }
    function nightness() { return clamp((scrollY - nStart) / (nEnd - nStart)); }
    var time = 0, last = 0, drawOnce = false, lastSc = -1, lastDay = -1;
    function draw(ts) {
      if (my !== gen) return;
      var dt = Math.min(50, ts - last || 16); last = ts;
      var kd = dt / 16.67;
      if (!reduce) time += dt / 1000;
      var t = nightness(), sc = scrollY, i;
      var day0 = clamp(1 - t * 1.6);
      if (willowBg && day0 !== lastDay) { willowBg.style.opacity = day0; lastDay = day0; }
      if (day0 > 0 && !reduce) bgSway.draw(time);
      if (cx && day0 < .995) {
        var g = cx.createLinearGradient(0, 0, 0, H);
        g.addColorStop(0, mix3('#a9cfc0', '#5b7d72', '#08100e', t));
        g.addColorStop(.6, mix3('#e6f0e9', '#c98a5b', '#12201c', t));
        g.addColorStop(1, mix3('#eef3ec', '#e9b98a', '#1a2a25', t));
        cx.fillStyle = g; cx.fillRect(0, 0, W, H);
        if (t > .45) {
          var sa = clamp((t - .45) / .4);
          for (i = 0; i < stars.length; i++) {
            var st = stars[i];
            cx.globalAlpha = sa * (.45 + .55 * Math.abs(Math.sin(time * .8 + st.tw)));
            cx.fillStyle = '#ece6c8'; cx.beginPath(); cx.arc(st.x * W, st.y * H, st.r, 0, 6.28); cx.fill();
          }
          cx.globalAlpha = 1;
        }
        var sunY = H * (.2 + t * .75);
        var sg = cx.createRadialGradient(W * .78, sunY, 0, W * .78, sunY, 140);
        sg.addColorStop(0, 'rgba(255,246,214,' + (.95 * (1 - t)) + ')');
        sg.addColorStop(.25, 'rgba(255,233,170,' + (.5 * (1 - t)) + ')');
        sg.addColorStop(1, 'rgba(255,233,170,0)');
        cx.fillStyle = sg; cx.beginPath(); cx.arc(W * .78, sunY, 140, 0, 6.28); cx.fill();
        var moonY = H * (1.05 - t * .85), mr = Math.min(W, H) * .055;
        if (t > .2) {
          var ma = clamp((t - .2) / .4);
          var mg = cx.createRadialGradient(W * .8, moonY, mr * .6, W * .8, moonY, mr * 4);
          mg.addColorStop(0, 'rgba(236,230,200,' + (.35 * ma) + ')'); mg.addColorStop(1, 'rgba(236,230,200,0)');
          cx.fillStyle = mg; cx.beginPath(); cx.arc(W * .8, moonY, mr * 4, 0, 6.28); cx.fill();
          cx.fillStyle = 'rgba(236,230,200,' + ma + ')'; cx.beginPath(); cx.arc(W * .8, moonY, mr, 0, 6.28); cx.fill();
        }
        var hazeC = mix3('#eef3ec', '#e9b98a', '#1a2a25', t);
        var layerCols = [['#b9d3c6', '#c2a58c', '#1d2c27'], ['#93b9a7', '#9a8573', '#18251f'], ['#6f9a86', '#6c6656', '#131d19'], ['#4a7464', '#433f35', '#0c1311']];
        var hazeAmt = [.55, .38, .2, 0], mob = W < 700;
        for (var rk2 = 0; rk2 < ridges.length; rk2++) {
          var rg2 = ridges[rk2], lc = layerCols[rk2];
          var base = H * ((mob ? .64 : .6) + rk2 * .08), amp2 = H * ((mob ? .12 : .16) - rk2 * .025);
          var shift = Math.min(sc * (.015 + rk2 * .02), 40 + rk2 * 30);
          cx.fillStyle = mix3(lc[0], lc[1], lc[2], t);
          cx.beginPath(); cx.moveTo(0, H);
          for (var q2 = 0; q2 < rg2.pts.length; q2++) cx.lineTo(q2 * rg2.step, base - rg2.pts[q2] * amp2 + shift);
          cx.lineTo(W, H); cx.closePath(); cx.fill();
          for (var ti = 0; ti < rg2.trees.length; ti++) {
            var tr = rg2.trees[ti], idx = Math.min(rg2.pts.length - 1, Math.round(tr.x / rg2.step));
            var ty = base - rg2.pts[idx] * amp2 + shift + 2;
            if (tr.kind) { cx.beginPath(); cx.moveTo(tr.x - tr.w * .45, ty); cx.lineTo(tr.x, ty - tr.h * 1.5); cx.lineTo(tr.x + tr.w * .45, ty); cx.fill(); }
            else { cx.beginPath(); cx.arc(tr.x, ty - tr.h * .45, tr.h * .5, 0, 6.28); cx.arc(tr.x + tr.w * .4, ty - tr.h * .3, tr.h * .38, 0, 6.28); cx.fill(); }
          }
          if (hazeAmt[rk2] > 0) {
            var hg = cx.createLinearGradient(0, base - amp2 + shift, 0, base + 60 + shift);
            hg.addColorStop(0, 'rgba(0,0,0,0)');
            hg.addColorStop(1, hazeC.replace('rgb', 'rgba').replace(')', ',' + hazeAmt[rk2] + ')'));
            cx.fillStyle = hg; cx.fillRect(0, base - amp2 + shift, W, amp2 + 60 + H);
          }
          if (rk2 < 3) {
            var mist = cx.createLinearGradient(0, base - 10 + shift, 0, base + 50 + shift);
            var mistA = (.18 + .1 * Math.sin(time * .3 + rk2)) * (1 - t * .5);
            mist.addColorStop(0, 'rgba(255,255,255,0)'); mist.addColorStop(.5, 'rgba(240,244,240,' + mistA + ')'); mist.addColorStop(1, 'rgba(255,255,255,0)');
            cx.fillStyle = mist; cx.fillRect(0, base - 10 + shift, W, 60);
          }
        }
        var day = day0;
        if (day > 0) {
          cx.save(); cx.globalCompositeOperation = 'lighter';
          var ox2 = W * .86, oy2 = -H * .12;
          for (var ri = 0; ri < 7; ri++) {
            var ang = Math.PI * .58 + ri * .1 + Math.sin(time * .12 + ri) * .03;
            var rg = cx.createLinearGradient(ox2, oy2, ox2 + Math.cos(ang) * H * 1.4, oy2 + Math.sin(ang) * H * 1.4);
            rg.addColorStop(0, 'rgba(255,246,214,' + (.16 * day) + ')'); rg.addColorStop(1, 'rgba(255,246,214,0)');
            cx.fillStyle = rg; cx.beginPath(); cx.moveTo(ox2, oy2);
            cx.lineTo(ox2 + Math.cos(ang - .025) * H * 1.4, oy2 + Math.sin(ang - .025) * H * 1.4);
            cx.lineTo(ox2 + Math.cos(ang + .025) * H * 1.4, oy2 + Math.sin(ang + .025) * H * 1.4); cx.fill();
          }
          for (i = 0; i < motes.length; i++) {
            var mo = motes[i]; mo.ph += .012 * kd;
            var my2 = (mo.y * H - (reduce ? 0 : time * 6)) % H; if (my2 < 0) my2 += H;
            cx.globalAlpha = day * (.25 + .5 * Math.abs(Math.sin(mo.ph)));
            cx.fillStyle = '#fff6d6'; cx.beginPath(); cx.arc(mo.x * W + Math.sin(mo.ph) * 6, my2, mo.r, 0, 6.28); cx.fill();
          }
          cx.restore();
          cx.globalAlpha = day;
          for (i = 0; i < leaves.length; i++) {
            var lf = leaves[i];
            if (!reduce) { lf.y += lf.vy * kd; lf.ph += .012 * kd; lf.x += Math.sin(lf.ph) * .35 * kd; lf.r += (lf.vr + Math.sin(lf.ph) * .004) * kd; }
            if (lf.y > H + 20) { lf.y = -20; lf.x = Math.random() * W; }
            cx.save(); cx.translate(lf.x, lf.y); cx.rotate(lf.r);
            cx.fillStyle = lf.c; cx.beginPath(); cx.ellipse(0, 0, lf.sz * .38, lf.sz, 0, 0, 6.28); cx.fill();
            cx.strokeStyle = 'rgba(40,62,54,.35)'; cx.lineWidth = .6; cx.beginPath(); cx.moveTo(0, -lf.sz); cx.lineTo(0, lf.sz); cx.stroke();
            cx.restore();
          }
          cx.globalAlpha = 1;
        }
        var shown = Math.round(flies.length * (.18 + .82 * t));
        for (i = 0; i < shown; i++) {
          var f = flies[i];
          if (!reduce) {
            f.ph += f.sp * kd; f.x += (f.vx + Math.sin(f.ph * .7) * .15) * kd; f.y += f.vy * (1 + t) * kd;
            if (f.y < -10) { f.y = H + 10; f.x = Math.random() * W; }
            if (f.x < -10) f.x = W + 10; if (f.x > W + 10) f.x = -10;
          }
          var gl = (.25 + .75 * Math.max(0, Math.sin(f.ph))) * (.45 + .55 * t);
          var fg = cx.createRadialGradient(f.x, f.y, 0, f.x, f.y, f.r * 8);
          fg.addColorStop(0, 'rgba(255,240,170,' + gl + ')'); fg.addColorStop(.3, 'rgba(255,224,120,' + (gl * .35) + ')'); fg.addColorStop(1, 'rgba(255,224,120,0)');
          cx.fillStyle = fg; cx.beginPath(); cx.arc(f.x, f.y, f.r * 8, 0, 6.28); cx.fill();
        }
      }
      if (sc !== lastSc) {
        lastSc = sc;
        if (!reduce && introEl && sc < sceneH) {
          introEl.style.setProperty('--w-py', (sc * .25) + 'px');
          scene && scene.style.setProperty('--w-part', clamp(sc / (sceneH * .85)).toFixed(3));
          introEl.style.setProperty('--w-lift', clamp(sc / (introEl.offsetHeight * .9)).toFixed(3));
        }
        if (bar) {
          bar.classList.toggle('scrolled', sc > 40);
          bar.classList.toggle('in-scene', !!opening && sc < sceneH * .55);
        }
      }
      if (!reduce || drawOnce) { drawOnce = false; requestAnimationFrame(draw); }
    }
    setup(); measure();
    addEventListener('load', measure);
    setTimeout(measure, 1500);
    addEventListener('resize', function () { setup(); measure(); lastSc = -1; if (reduce) { drawOnce = true; requestAnimationFrame(draw); } });
    if (reduce) addEventListener('scroll', function () { drawOnce = true; requestAnimationFrame(draw); }, { passive: true });
    requestAnimationFrame(draw);
  }

  function boot() { initHeader(); initHome(); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', boot); else boot();

  /* theme editor: rebuild the magic when a section is edited */
  if (design) {
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (ev) {
      doc.addEventListener(ev, function (e) {
        var id = e.target && e.target.id || '';
        if (/header/.test(id)) { initHeader(); }
        setTimeout(initHome, 50);
      });
    });
  }
})();